import React from 'react';
import Icon from 'components/icon';
import AppIcon from 'components/apps/icon';
import Tooltip from 'components/tooltip';

export default function StorefrontIcon({ app, size = 24 }) {
  const { theme, storefront } = app;

  return (
    <>
      {theme?.storefront?.compatibility?.shopify ? (
        <Tooltip message="This is a Shopify compatible theme">
          <Icon svgType="themes/shopify" width={size} height={size} />
        </Tooltip>
      ) : (
        storefront?.kind === 'shop' && <AppIcon app={app} size={size} />
      )}
    </>
  );
}
